import Card from '../UI/Card';
import FormField from '../UI/FormField';
import { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { IProduct } from '@/interfaces/product.interface';

interface ProductPricingProps {
  type: 'public' | 'employee';
  register: UseFormRegister<IProduct>;
  watch: UseFormWatch<IProduct>;
}

const ProductPricing: React.FC<ProductPricingProps> = ({
  type,
  register,
  watch,
}) => {
  const prefix = 'productInfo.0.';
  const empPrefix = `${prefix}meta.employee.`;
  const empDiscountType = watch(`${empPrefix}discount.type`);
  return (
    <Card>
      <h2 className="text-lg font-semibold mb-6">
        {type === 'public' ? 'Public Pricing' : 'Employee Pricing'}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-1 gap-4">
        {type == 'public' ? (
          <FormField
            prefix="BD"
            label="Price"
            placeholder="Enter price"
            readOnly
            disabled
            {...register(`${prefix}price` as const)}
          />
        ) : (
          <FormField
            type="select"
            prefix="BD"
            label="Price Type"
            options={[
              { value: 'percentage', label: 'Percentage' },
              { value: 'flat', label: 'Flat' },
            ]}
            {...register(`${empPrefix}discount.type`)}
          />
        )}
        {/* <FormField
                    prefix="BD"
                    label="Compare at Price"
                    placeholder="Enter compare at price"
                // {...register(`${prefix}compareAtPrice` as const, { valueAsNumber: true })}
                />
                <FormField
                    prefix="BD"
                    label="Cost per Item"
                    placeholder="Enter cost per item"
                // {...register(`costPerItem` as const, { valueAsNumber: true })}
                />
                <FormField
                    prefix="BD"
                    label="Profit"
                    placeholder="Enter profit"
                // {...register(`profit` as const, { valueAsNumber: true })}
                />
                <FormField
                    prefix="BD"
                    label="Margin"
                    placeholder="Enter margin percentage"
                    suffix="%"
                // {...register(`margin` as const, { valueAsNumber: true })}
                /> */}
        {/* {type === 'public' && (
          <div>
            <FormField
              type="number"
              label="Loyalty Points"
              placeholder="Enter loyalty points"
              min={0}
              {...register(`${prefix}loyaltyPoints` as const, {
                valueAsNumber: true,
              })}
            />
          </div>
        )} */}
        {type === 'employee' && (
          <div>
            <FormField
              prefix={empDiscountType === 'flat' ? 'BD' : undefined}
              suffix={empDiscountType === 'percentage' ? '%' : undefined}
              type="number"
              label="Value"
              placeholder="Enter Discount Value"
              min={0}
              onWheel={(e) => e.currentTarget.blur()}
              step="0.001"
              {...register(`${empPrefix}discount.value`, {
                valueAsNumber: true,
              })}
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default ProductPricing;
